


















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import constants from "../../config/constants";

@Component
export default class DeleteProductDialog extends Vue {
  @Prop() product!: any;
  @Prop() dialogDelete!: boolean;
  @Prop() page!: number;

  loadingDelete = false;

  private cancelDelete(): void {
    this.$emit("cancelDelete");
  }

  private removeProduct(): void {
    this.loadingDelete = true;
    this.$store
      .dispatch("product/updateProduct", {
        productId: this.product.productID,
        photoUrl: this.product.productPhotoURL,
        status: constants.STATUS.DELETED,
        start: this.page * constants.ITEMS_PER_PAGE - constants.ITEMS_PER_PAGE,
        quantity: constants.ITEMS_PER_PAGE,
        page: this.page
      })
      .then((response: boolean) => {
        if (response) {
          this.$emit("openSuccessSnackbar");
        } else {
          this.$emit("openErrorSnackbar");
        }

        this.loadingDelete = false;
        this.$emit("cancelDelete");
      });
  }
}
